// @styles
require('./aggregatorInfo.scss');

// @vendors
import React from 'react'

// @components
import { ContentBox } from 'commonsComponents/contentBox';

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;

function AggegatorInfo() {
    return (
        <ContentBox
            title={formatText("aggregatorCredentialsView-infoTitle")}
            smallTitle={true}
        >
            <div className="aggegator-info__content">
                <div className="aggegator-info__content__list">
                    <ul>
                        <li className="aggegator-info__content__list__item">{formatText("aggregatorCredentialsView-infoStep1")}</li>
                        <li className="aggegator-info__content__list__item">{formatText("aggregatorCredentialsView-infoStep2")}</li>
                        <li className="aggegator-info__content__list__item">{formatText("aggregatorCredentialsView-infoStep3")}</li>
                    </ul>
                </div>
                <div data-gtns-component-name="sidebar como anadir entidad" className="aggegator-info__content__faq">
                    <FormattedText value="aggregatorCredentialsView-faq" />
                </div>
                <i className="aggegator-info__content__icon icon icon-informacion" />
            </div>
        </ContentBox>
    )
}

export default AggegatorInfo;
